import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'pdf-button',
  imports: [MatIconModule, MatButtonModule, MatMenuModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (menuItems?.length > 1) {
      <button
        matButton="filled"
        type="button"
        class="charcoal-button h-24! w-32! min-w-32! p-0! font-semibold! legal"
        [matMenuTriggerFor]="pdfMenu"
        (click)="$event.stopPropagation()">
        PDF
        <mat-icon iconPositionEnd class="size-10! text-10! ml-0! -mr-[3px]!">arrow_drop_down</mat-icon>
      </button>
    } @else {
      <button
        matButton="filled"
        type="button"
        class="charcoal-button h-24! w-32! min-w-32! p-0! font-semibold! legal"
        (click)="openPDF.emit(menuItems?.length ? menuItems[0].value : ''); $event.stopPropagation()">
        PDF
      </button>
    }
    <mat-menu #pdfMenu="matMenu" xPosition="before" yPosition="below">
      @for (item of menuItems; track item) {
        <button (click)="openPDF.emit(item.value)" class="min-h-[28px]" mat-menu-item>
          <mat-icon class="w-[18px] h-[18px] text-[18px] mr-10">picture_as_pdf</mat-icon>
          <span class="body-1">{{ item.label }}</span>
        </button>
      }
    </mat-menu>
  `
})
export class PdfButtonComponent {
  @Input() menuItems: { label: string; value: string }[] = [];
  @Output() openPDF = new EventEmitter<string>();
}
